import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CommonButton } from 'gemlux-common-components';
import { Box } from '@mui/material';
import Question from '../../components/SignUp/Question/Question';
import { LOGIN_ROUTE } from '../../utils/routes';
import { useAppSelector } from '../../redux/hooks';
import Subscription from '../../components/SignUp/Subscription/Subscription';
import Role from '../../components/SignUp/Role/Role';
import Credential from '../../components/SignUp/Credential/Credential';
import Otp from '../../components/SignUp/Otp/Otp';
import { handleGoBackTo } from '../../utils/general.utils';
import { RootState } from '../../redux/store';
import IconButtonLeft from '../../assets/img/icon-btn-left.svg';

function SignUp() {
  const signUpData = useAppSelector((state: RootState) => state.auth.signUpData);
  const [activeStep, setActiveStep] = useState<number>(signUpData.lastActiveStep);
  const businessEmail = useAppSelector((state: RootState) => state.auth.credentials.businessEmail);
  const navigate = useNavigate();

  const handleBack = () => {
    if (activeStep === 0) {
      handleGoBackTo(navigate, LOGIN_ROUTE);
    } else {
      setActiveStep(activeStep - 1);
    }
  };

  return (
    <Box>
      {activeStep === 0 && (
        <Question
          section1="Porolis GemLUX® AI-driven Software-as-a-Service is best used together with the KROMA™ / KRISTA™
          photomicrography device"
          section2="Do you own a KROMA™ / KRISTA™ ?"
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      )}
      {activeStep === 1 && (
        <Question
          section1="Do you have access to KROMA™ / KRISTA™ scanning services provided by 
                    GemLUX® Xperience Hub or other 3rd-Party Partners?"
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      )}
      {activeStep === 2 && (
        <Question
          section1="You can still benefit from GemLUX® AI-solutions for colour-grading and viewing 
                    of all gemstone listing in our GemBANK™ database."
          section2="Click continue to proceed with the registration process for a free trial period of 3 months"
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          rightButtonText="Inquire about KROMA™ / KRISTA™"
          leftButtonText="Continue"
        />
      )}
      {activeStep === 3 && <Subscription setActiveStep={setActiveStep} />}
      {activeStep === 4 && <Role setActiveStep={setActiveStep} />}
      {activeStep === 5 && (
        <Credential
          setActiveStep={setActiveStep}
          activeStep={activeStep}
          title="Please enter your personal credentials"
        />
      )}
      {activeStep === 6 && (
        <Credential
          setActiveStep={setActiveStep}
          activeStep={activeStep}
          title="Please enter your business credentials"
        />
      )}
      {activeStep === 7 && <Otp email={businessEmail} />}
      {activeStep !== 3 && activeStep !== 5 && activeStep !== 6 && activeStep !== 7 && (
        <CommonButton
          variant="text"
          fullWidth
          sx={{
            background: ' #F6F7F9',
            padding: '30px 24px',
            borderRadius: '0px 0px 8px 8px',
            border: '1px solid #DCE0E5',
            display: 'flex',
            borderTop: '0',
            justifyContent: activeStep === 0 ? 'center' : 'flex-start',
          }}
          onClick={handleBack}
        >
          <Box component="img" src={IconButtonLeft} alt="Back Arrow" sx={{ marginRight: '8px' }} />
          <Typography color="#3348FF" variant="textBase500">
            {activeStep === 0 ? 'Go Home' : 'Go Previous'}
          </Typography>
        </CommonButton>
      )}
    </Box>
  );
}

export default SignUp;
